const B_1 = [
    {
        title: '中标结果公告审核',
        path: '/manage/business/audit-zbjggg/list'
    }
]

export default {
    path: 'auditzbjggg',
    component: () => import(/*webpackChunkName: 'business-auditzbjggg'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/manage/views/business/audit-zbjggg/list'),
            meta: {
                title: '中标结果公告审核',
                topNav: true,
                bread: B_1
            },
        }
    ]
}
